import { c as _c } from "react/compiler-runtime";
export default function CreateWaveInlineGroupDraftSummary(t0) {
  const $ = _c(21);
  const {
    draftSummary,
    isValid,
    canResetDraft,
    canCreateDraft,
    isCreating,
    onClearAll,
    onCreateAndUse
  } = t0;
  const showDraftActions = draftSummary !== null;
  if (!showDraftActions) {
    return null;
  }
  let t1;
  if ($[0] !== isValid) {
    t1 = !isValid && <p className="tw-mb-3 tw-text-xs tw-text-iron-400"><span className="tw-font-semibold tw-text-iron-300">Not ready yet.</span>{" "}<span>Finish the missing group rules before you create this group.</span></p>;
    $[0] = isValid;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-500">Create this new group</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== draftSummary) {
    t3 = <div className="tw-flex tw-min-w-0 tw-flex-col tw-gap-1">{t2}<p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-400">{draftSummary}</p></div>;
    $[3] = draftSummary;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !canResetDraft;
  let t5;
  if ($[5] !== onClearAll || $[6] !== t4) {
    t5 = <button type="button" disabled={t4} onClick={onClearAll} className="tw-rounded-lg tw-border tw-border-solid tw-border-transparent tw-bg-transparent tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-iron-400 tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-text-iron-100">Discard draft</button>;
    $[5] = onClearAll;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = !canCreateDraft;
  const t7 = isCreating ? "Creating group..." : "Create and use new group";
  let t8;
  if ($[8] !== onCreateAndUse || $[9] !== t6 || $[10] !== t7) {
    t8 = <button type="button" disabled={t6} onClick={onCreateAndUse} className="tw-rounded-lg tw-border tw-border-solid tw-border-primary-500 tw-bg-primary-500 tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-transition tw-duration-200 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-border-primary-400 desktop-hover:hover:tw-bg-primary-400">{t7}</button>;
    $[8] = onCreateAndUse;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2">{t5}{t8}</div>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t9) {
    t10 = <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">{t3}{t9}</div>;
    $[15] = t3;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t1 || $[19] !== t10) {
    t11 = <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-pt-5">{t1}{t10}</div>;
    $[18] = t1;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}